import popMgr from '@/components/global/popMgr';
const styleMap = {
    standard: () =>
        import(
            /* webpackChunkName: "common/leave-msg/standard"*/ './standard.vue'
        ),
    template1: () =>
        import(
            /* webpackChunkName: "common/leave-msg/template1"*/ './template1.vue'
        ),
    template4: () =>
        import(
            /* webpackChunkName: "common/leave-msg/template4"*/ './template4.vue'
        ),
    broker: () =>
        import(/* webpackChunkName: "common/leave-msg/broker"*/ './broker.vue')
};

const psMap = {};

const leaveMsg = {
    prepare(style = window.sitePrepareData().template) {
        if (!psMap[style]) {
            psMap[style] = styleMap[style]();
        }
        return psMap[style];
    },
    open(options = {}, style, action = 'closeOtherPop', skipRegister = false) {
        var globalData = window.sitePrepareData();
        let { newDisclaimersMap = {} } = globalData;
        options.openCustomDisclaimers = true
        options.customDisclaimers = newDisclaimersMap.customDisclaimers;
        style = style || globalData.template;
        // landing page based on page level leadType to set role the value of 
        if (globalData.leadType && !globalData.isRegUserTypeByPurchaseType) {
            options.role = globalData.leadType;
        }

        const vdata = {
            options: options,
            skipRegister
        };
        this.prepare(style).then(pop => {
            popMgr.create(pop.default, vdata, action);
        });
    }
};

export default leaveMsg;
